module.exports = __webpack_public_path__ + "img/list_portrait_default_men@3x.bce71ed1.png";